<script>
import template from './template.html';
import repository from './repository';

const PTJ_Worker022 = {
    name: 'PTJ_Worker022',
    template,
    emits: ['close'],
    data() {
        const currentYear = new Date().getFullYear();
        return {
            step: 'confirm',
            selectedYear: String(currentYear - 1),
            yearOptions: [
                { value: String(currentYear - 2), label: String(currentYear - 2) },
                { value: String(currentYear - 1), label: String(currentYear - 1) },
                { value: String(currentYear), label: String(currentYear) }
            ],
            completeMessage: '',
            isSubmitting: false
        };
    },
    methods: {
        closePopup() {
            this.$emit('close');
        },
        getUserInfo() {
            try {
                return JSON.parse(localStorage.getItem('userInfo') || '{}');
            } catch (e) {
                return {};
            }
        },
        async submit() {
            if (this.isSubmitting) {
                return;
            }

            const userInfo = this.getUserInfo();
            const payload = {
                company_cd: userInfo.company_cd || userInfo.CompanyCD || 0,
                staff_id: userInfo.staff_id || userInfo.StaffID || userInfo.user_id || 0,
                request_year: this.selectedYear
            };

            this.isSubmitting = true;
            try {
                const response = await repository.store(payload);
                const result = response?.data || {};

                if (result.Code !== 200) {
                    this.completeMessage = result.Message || 'エラーが発生しました。';
                    this.step = 'done';
                    return;
                }

                const status = result.Data?.status || 'done';
                const requestYear = result.Data?.request_year || this.selectedYear;

                if (status === 'duplicate') {
                    this.completeMessage = `既に${requestYear}年度の発行依頼を行っています！`;
                } else {
                    this.completeMessage = '源泉徴収票の発行を依頼しました！';
                }

                this.step = 'done';
            } catch (e) {
                this.completeMessage = e.message || 'エラーが発生しました。';
                this.step = 'done';
            } finally {
                this.isSubmitting = false;
            }
        }
    }
};

export default PTJ_Worker022;
</script>

<style lang="scss" scoped>
@use '@/assets/scss/common/popup.scss' as *;

#modal_PTJ_Worker022 {
    .w-popup {
        background: #fff;
        border: 1px solid #4a4a4a;
    }

    .w-header-popup {
        background: #005ea8;
        color: #fff;
        font-size: 14px;
        font-weight: 700;
        padding: 8px 12px;
    }

    .popup-body {
        padding: 16px 20px 20px;
        text-align: center;
    }

    .year-select {
        width: 114px;
        height: 28px;
        border: 1px solid #7f7f7f;
        margin-bottom: 12px;
    }

    .confirm-message,
    .done-message {
        color: #333;
        font-size: 14px;
        margin-bottom: 18px;
        min-height: 22px;
    }

    .popup-actions {
        display: flex;
        justify-content: center;
        gap: 28px;
    }

    .popup-btn {
        min-width: 72px;
        height: 28px;
        border: 1px solid #7f7f7f;
        background: #e9e9e9;
        color: #333;
        font-size: 14px;
    }
}
</style>
